import { format, formatDistance, formatRelative, subDays } from 'date-fns'
//import { pt, en, es, de } from 'date-fns/locale' //v2
// var locales = {
//     en: import ('date-fns/locale/en-US'),
//     pt: import ('date-fns/locale/pt-BR'),
//     es: import ('date-fns/locale/es')
// }
// import en from 'date-fns/locale/en-US'
// import pt from 'date-fns/locale/pt-BR'
// import es from 'date-fns/locale/es'
// registerLocale('en', en)
// registerLocale('pt', pt)
// registerLocale('es', es)

import { ptBR, enUS, es, de } from 'date-fns/locale'

export const DateFormat = {

    semFormatacao: '*',

    formatDate(date, formatting, locale = 'pt') {
        let lo = this.getLocale(locale)
        
        if(formatting == this.semFormatacao || date == null)
            return date
                
        if (typeof date == 'string')
            date = new Date(date)
        return format(date, formatting, {locale: lo})
    },
    commonFormats(locale = 'pt') {
        
        let dt = new Date(2037, 5, 20, 14, 7, 19, 0);
        let _this = this;
        function getFormatting(formatting) {
            return { formatting, example: _this.formatDate(dt, formatting, locale), type: 'datetime'}
        }
        return [
            getFormatting('*'),
            getFormatting('dd/MM/yyyy'),
            getFormatting('dd/MM/yy'),
            getFormatting('d/M/yy'),
            getFormatting('MM/dd/yyyy'),
            getFormatting('MM/dd/yy'),
            getFormatting('M/d/yy'),
            getFormatting('HH:mm:ss'),
            getFormatting('hh:mm:ss'),
            getFormatting('HH:mm'),
            getFormatting('hh:mm'),
            getFormatting('mm:ss'),
            getFormatting('mm'),
            getFormatting('m'),
            getFormatting('dd/MM/yyyy HH:mm:ss'),
            getFormatting('dd/MM/yyyy hh:mm:ss'),
            getFormatting('dd/MM/yyyy HH:mm'),
            getFormatting('dd/MM/yyyy hh:mm'),
            getFormatting('dd-MM-yyyy'),
            getFormatting('ddMMyyyy'),
            getFormatting('ddMMyy'),
            getFormatting('MMddyyyy'),
            getFormatting('MMddyy'),
        ]
    },
    // getLocale(strLocale) {
    //     switch (strLocale) {
    //         case 'pt':
    //             return locales.pt;
    //         case 'en':
    //             return locales.en;
    //         case 'es':
    //             return locales.es;
    //         default:
    //             return locales.pt;
    //     }
    // },
    getLocale(strLocale) {
        switch (strLocale) {
            case 'pt':
                return ptBR;
            case 'en':
                return enUS;
            case 'es':
                return es;
            default:
                return ptBR;//pt;
        }
    },
    locales() {
        return [
            { description: 'locale-portugues', locale: 'pt' },
            { description: 'locale-ingles', locale: 'en' },
            { description: 'locale-espanhol', locale: 'es' }
        ]
    }
}